import { colors } from '../../../../themes/theme'

/**
 * Geometry shared by the Blueprint tab timeline, its rows and its skeleton so the
 * spine, the branch stubs and the dots line up across all three.
 */

/** Width of the grid column the spine and its branch stubs live in. */
export const SPINE_COLUMN_WIDTH = 44
/** Horizontal center of the vertical spine inside that column. */
export const SPINE_CENTER = 22
/** Left offset of the 2px spine line (centered on `SPINE_CENTER`). */
export const SPINE_LINE_LEFT = SPINE_CENTER - 1
/** Length of the horizontal stub branching off the spine towards a card. */
export const SPINE_STUB_WIDTH = 26
/** Diameter of the "Present" node at the top of the spine. */
export const SPINE_NODE_SIZE = 22
/** Diameter of a per-entry dot. */
export const SPINE_DOT_SIZE = 10
/** White ring drawn around a per-entry dot. */
export const SPINE_DOT_RING = 3
/** Gap between the spine column and the card column. */
export const SPINE_COLUMN_GAP = '16px'
/** Height of the spine head's line, sized to the page chip — the tallest thing it holds. */
export const HEAD_LINE_HEIGHT = 28
/** Vertical axis of the head: the node is centered on it and the spine drops from it. */
export const HEAD_NODE_OFFSET = HEAD_LINE_HEIGHT / 2
/** Height of a collapsed card line: 24px chevron + 10px padding + 1px border, top and bottom. */
export const ROW_COLLAPSED_HEIGHT = 46
/** Vertical distance from a row's top to the middle of its collapsed card line. */
export const ROW_NODE_OFFSET = ROW_COLLAPSED_HEIGHT / 2
/** Vertical breathing room under each row — padding, so the spine keeps running through it. */
export const ROW_BOTTOM_SPACING = '10px'
/** Neutral spine gray; deliberately the subtle neutral rather than a brand colour (see the 1e spec). */
export const SPINE_COLOR = colors.subtle
